// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('SharedUserRightVO')
export class SharedUserRightVO {
  @JsonProperty('userId', 'Number')
  public userId: number = undefined;

  @JsonProperty('sharedFromUserId', 'Number')
  public sharedFromUserId: number = undefined;

  @JsonProperty('isReadable', 'Boolean')
  public isReadable: boolean = undefined;

  @JsonProperty('isEditable', 'Boolean')
  public isEditable: boolean = undefined;

  @JsonProperty('isAutomaticApplied', 'Boolean')
  public isAutomaticApplied: boolean = undefined;

  @JsonProperty('updateChildrenAvailable', 'Boolean')
  public updateChildrenAvailable: boolean = undefined;

  // override default object method toJSON() (which is invoked when the object should be serialize)
  // to exclude transient properties and send correct object to server
  public toJSON() {
    return {
      userId: this.userId,
      sharedFromUserId: this.sharedFromUserId,
      isReadable: this.isReadable,
      isEditable: this.isEditable,
      updateChildrenAvailable: this.updateChildrenAvailable
    };
  }
}
